import { render } from "./UeMaterialsListView.vue?vue&type=template&id=39012ccd&scoped=true"
import script from "./UeMaterialsListView.vue?vue&type=script&lang=js"
export * from "./UeMaterialsListView.vue?vue&type=script&lang=js"

import "./UeMaterialsListView.vue?vue&type=style&index=0&id=39012ccd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39012ccd"]])

export default __exports__